import React, { useEffect, useState } from 'react';
const headlines = ['Was bedeutet „Potenzial" überhaupt?', 'Wie lässt sich Potenzial für komplexere Aufgaben feststellen?'];
export const PotenzialanalysenPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white pt-16 pb-0 px-6 md:px-12 lg:px-20" data-id="element-611">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-612">
          <div data-id="element-613">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '120px'
          }} data-id="element-614">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-615">
            <img src="https://cdn.magicpatterns.com/uploads/3YHMaGvcBbXs2R2FLM82nj/Eva-Schifferer-Management_Diagnostik-Potentialanalysen.png" alt="Potenzialanalysen Kartenhaus" className="max-h-96 object-contain" data-id="element-616" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-617">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-618">
          <div data-id="element-619">
            <p className="mb-6 text-base leading-relaxed" data-id="element-620">
              In unserer Welt der schnellen Veränderung, geprägt von zunehmender
              Komplexität und Unsicherheit, ist Potenzial für neue Aufgaben ein
              Schlüsselfaktor des Erfolgs. Denn nichts bleibt, wie es war.
              Lernfähigkeit, die Fähigkeit zur Selbstreflexion,
              Komplexitätsreduktion, Umgang mit Unsicherheit sind in unserer
              Welt der agilen Veränderung Erfolgsfaktoren. Für Unternehmen von
              großer Bedeutung ist die Frage nach
            </p>
            <ul className="mb-6 space-y-3 text-base leading-relaxed" data-id="element-621">
              <li className="flex items-start" data-id="element-622">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-623"></span>
                <span data-id="element-624">
                  der Lernbereitschaft für neue Aufgaben in
                  Veränderungsprozessen
                </span>
              </li>
              <li className="flex items-start" data-id="element-625">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-626"></span>
                <span data-id="element-627">
                  dem Potenzial in der individuellen Laufbahnbestimmung
                </span>
              </li>
            </ul>
            <p className="mb-6 text-base leading-relaxed" data-id="element-628">
              Wir erarbeiten fundierte Potenzialaussagen auf Basis der gemeinsam
              festgelegten Potenzialindikatoren (= die Antwort auf die Frage:
              Potenzial wofür?) und erstellen kompakte, auf den Punkt gebrachte
              Entwicklungsempfehlungen.
            </p>
          </div>
          <div data-id="element-629">
            <p className="mb-6 text-base leading-relaxed font-semibold" data-id="element-630">
              Die Methoden der Potenzialanalyse beinhalten
            </p>
            <ul className="mb-6 space-y-3 text-base leading-relaxed" data-id="element-631">
              <li className="flex items-start" data-id="element-632">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-633"></span>
                <span data-id="element-634">biographische und kompetenzorientierte Interviews</span>
              </li>
              <li className="flex items-start" data-id="element-635">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-636"></span>
                <span data-id="element-637">Selbst- und Fremdeinschätzungen</span>
              </li>
              <li className="flex items-start" data-id="element-638">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-639"></span>
                <span data-id="element-640">
                  psychologische Testverfahren zur Persönlichkeits- und
                  Motivstruktur
                </span>
              </li>
              <li className="flex items-start" data-id="element-641">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-642"></span>
                <span data-id="element-643">auf die Potenzialindikatoren zugeschnittene Übungen</span>
              </li>
              <li className="flex items-start" data-id="element-644">
                <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-white rounded-full flex-shrink-0" data-id="element-645"></span>
                <span data-id="element-646">
                  in Veränderungsprozessen Workshops zur Selbsteinschätzung und
                  Selbstreflexion
                </span>
              </li>
            </ul>
            <p className="mb-6 text-base leading-relaxed" data-id="element-647">
              Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!
            </p>
            <a href="/kontakt" className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition-colors" data-id="element-648">
              Lassen Sie uns sprechen
            </a>
          </div>
        </div>
      </section>
    </>;
};